import { UncubesQuery } from '@dynameat/views/reporting/models/uncubesQuery';

export class MarginQuery extends UncubesQuery {
  DAYS_BEFORE = 14

  projection = 'ticket_sales'

  cuts = []

  cols = [
    { kpi: 'product_group_of_pricing' }
  ]

  aggregates = [
    { kpi: 'ticket_line_amount', function: 'SUM' },
    { kpi: 'ticket_line_cost', function: 'SUM' },
    { kpi: 'ticket_line_quantity', function: 'SUM' },
  ]

  limit = 1

  // YYYY-MM-DD date with timezone taken in account
  getDateForQuery(date) {
    const offset = date.getTimezoneOffset();
    const offsetDate = new Date(date.getTime() - (offset * 60 * 1000));
    return offsetDate.toISOString().split('T')[0];
  }

  constructor(productGuid = null, groupPricingName = null) {
    super();
    const today = new Date();
    const todayString = this.getDateForQuery(today);
    const dayBefore = new Date();
    dayBefore.setDate(today.getDate() - this.DAYS_BEFORE);
    const dayBeforeString = this.getDateForQuery(dayBefore);
    this.cuts = [
      { expression: `ticket_line_date between '${dayBeforeString}' and '${todayString}'` }];
    if (productGuid) {
      this.cuts.push({ expression: `product_guid = '${productGuid}'` });
    }
    if (groupPricingName) {
      this.cuts.push({ expression: `product_group_of_pricing = '${groupPricingName}'` });
    }
  }
}
